import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EditComponent} from '../../../core/components/edit-component';
import {NgForm} from '@angular/forms';
import {
  ApiResponse,
  ClassificatorsQuery,
  ClassificatorValueQuery,
  ClassificatorValuesQuery,
  GLOBAL,
  LeModalService
} from 'common-shared';
import {ClassificatorModel} from '../../../system/classificator/models/classificator.model';
import {ClassificatorValueModel} from '../../../system/classificator/models/classificator-value.model';
import {JsonEditorModalComponent} from "../../json-editor-modal/json-editor-modal.component";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'mes-web-classificator-edit',
  templateUrl: './classificator-edit.component.html',
})
export class ClassificatorEditComponent extends EditComponent implements OnInit {
  @Input() response: ApiResponse<any>;
  @Input() classificator: ClassificatorModel;
  @Output() changed = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;
  classificatorTypes$: Observable<ClassificatorValueQuery[]> = this.classificatorValuesQuery.getAll$.pipe(map(clvs => clvs.filter(clv => clv.ClassificatorId === GLOBAL.Classificators.ClassificatorType.ClassificatorId)));
  classificators = GLOBAL.Classificators;
  constructor(public classificatorsQuery: ClassificatorsQuery, public classificatorValuesQuery: ClassificatorValuesQuery, private changeDetector: ChangeDetectorRef, private leModalService: LeModalService) {
    super();
  }

  ngOnInit() {
    this.form.statusChanges.subscribe(value => {
      this.changed.emit(this.form.pristine);
    });
  }

  addValue() {
    this.classificator.Values.push(ClassificatorValueModel.Create());
    this.changeDetector.detectChanges();
  }

  removeValue(classificatorValueModel: ClassificatorValueModel): void {
    this.classificator.Values = [...this.classificator.Values.filter(value => value !== classificatorValueModel)];
    this.form.controls.code.markAsDirty();
    this.changeDetector.detectChanges();
  }

  editData(clv: ClassificatorValueModel) {
    this.leModalService.show(JsonEditorModalComponent, {initialState: {title: clv.Code, jsonContent: clv.Data || '{}'}, class: 'modal-lg'}).onHide$.subscribe(value => {
      clv.Data = value.data === '{}' ? null : value.data;
    });
  }
}
